import MUIDataTable from 'mui-datatables';
import * as React from 'react';
import * as Redux from 'react-redux';

import {
  Avatar,
  Grid,
  Stack,
  TableCell,
  TableRow,
  Typography,
} from '@mui/material';
import * as CONST from '../../../../constants/FieldsConst';
import { textLabels } from '../../../../helpers';
import { useNotification } from '../../../../helpers/Notification';
import { LoadingWidget } from '../../../../widgets';
import ActionsListWidget from '../../../../widgets/ActionsList';
import DeleteModalComponent from '../../../../widgets/modals/DeleteModal';
import { getFilesArchivos } from '../../../archivos/HelpersArchivos';
import { NameComponent } from '../../../usuario/usuarios/components/ListadoUsuarios';
import {
  allFamiliaresAction,
  deleteFamiliaresAction,
  setActivoFamiliaresAction,
} from '../FamiliaresAction';
import { PARAMS_FAMILIARES } from '../FamiliaresReducer';
import DetalleExpandeFamiliares from './DetalleExpandeFamiliares';

const ListadoFamiliares = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const loginStore = Redux.useSelector((state) => state.login);
  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const familiaresStore = Redux.useSelector((state) => state.familiares);

  const [loading, setLoading] = React.useState(false);
  const [openModalDelete, setOpenModalDelete] = React.useState(false);
  const [rows, setRows] = React.useState([]);

  let intervalSearch = null;

  async function all(payload) {
    await allFamiliaresAction(dispatch, payload);
  }

  React.useEffect(() => {
    const fetchData = async () => {
      const payload = {
        ...familiaresStore.params,
        idEntidad: entidadesStore.activo.id,
      };

      dispatch({ type: PARAMS_FAMILIARES, payload });
      await all(payload);
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    const rows = [];
    familiaresStore.all.forEach((el) => {
      rows.push({
        ...el,
        foto: el.familiar.perfil.avatar,
        dni: `${el.familiar.perfil.tipoDni}-${el.familiar.perfil.dni}`,
        nombre: {
          nombre: `${el.familiar.perfil.pnombre} ${el.familiar.perfil.papellido}`,
          correo: el.familiar.correo,
        },
        actions: el,
      });
    });
    setRows(rows);
  }, [familiaresStore.all]);

  // const _handleEditClick = async (id) => {
  //   const data = familiaresStore.all.find((el) => el.id === id);
  //   await setActivoFamiliaresAction(dispatch, data);
  //   setOpenModalForm(true);
  // };

  const _onDeleteHandler = async () => {
    setLoading(true);
    await deleteFamiliaresAction(
      { dispatch, notify },
      familiaresStore.activo.id,
      familiaresStore.params,
    );
    setOpenModalDelete(false);
    setLoading(false);
  };

  const columns = [
    {
      name: CONST.ID,
      options: {
        display: loginStore.isRoot ? false : 'excluded',
        filter: false,
      },
    },
    {
      name: CONST.foto.name,
      label: CONST.foto.label,
      width: '10%',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Avatar
              alt={value}
              sx={{ width: 30, height: 30 }}
              src={getFilesArchivos(value)}
            />
          );
        },
      },
    },
    {
      name: CONST.dni.name,
      label: CONST.dni.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <NameComponent
            // onClick={() => _handleEditClick(tableMeta.rowData[0])}
            >
              {value}
            </NameComponent>
          );
        },
      },
    },
    {
      name: CONST.nombre.name,
      label: 'Nombres y apellidos',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <>
              <NameComponent
              // onClick={() => _handleEditClick(tableMeta.rowData[0])}
              >
                {value.nombre}
              </NameComponent>
              <Typography>{value.correo}</Typography>
            </>
          );
        },
      },
    },
    {
      name: 'parentesco',
      label: 'Parentesco',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'estudiante',
      label: 'Estudiante',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Stack direction="column">
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
              >
                <Typography
                  variant="subTitle1"
                  color="initial"
                  sx={{ fontWeight: 'bold' }}
                >
                  {value.perfil.tipoDni}-{value.perfil.dni}{' '}
                  {value.perfil.pnombre} {value.perfil.papellido}
                </Typography>
              </Stack>
              {value.entidades[0].matricula?.secciones.length > 0 ? (
                <Typography sx={{ fontSize: '10pt' }}>
                  <strong>Nivel: </strong>
                  {
                    value.entidades[0].matricula.secciones[0].seccion
                      .nivelAcademico.nivelAcademico.nombre
                  }{' '}
                  <strong>Sección: </strong>
                  {
                    value.entidades[0].matricula.secciones[0].seccion.nombre
                  }{' '}
                  <strong>Turno: </strong>
                  {value.entidades[0].matricula.secciones[0].seccion.turno}
                </Typography>
              ) : (
                <Typography sx={{ fontSize: '10pt' }} color="error">
                  <strong>No tiene matrícula</strong>
                </Typography>
              )}
            </Stack>
          );
        },
      },
    },
    {
      name: CONST.actions.name,
      label: CONST.actions.label,
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Stack direction="row">
              {/* <Tooltip describeChild title="Panel de gestión" placement="top">
                <IconButton
                  color="secondary"
                  size="small"
                  aria-label="Panel de gestión"
                  onClick={async () => {
                    await setActivoFamiliaresAction(dispatch, value);
                    history.push(ROUTES.panelFamiliares.to);
                  }}
                >
                  <DashboardIcon />
                </IconButton>
              </Tooltip> */}
              <ActionsListWidget
                id={tableMeta.rowData[0]}
                onDelete={async () => {
                  await setActivoFamiliaresAction(dispatch, value);
                  setOpenModalDelete(true);
                }}
                onDownload={() => {
                  window.open(value.url);
                }}
              />
            </Stack>
          );
        },
      },
    },
  ];

  const options = {
    filterType: 'dropdown',
    setTableProps: () => {
      return {
        padding: 'none',
        size: 'small',
      };
    },
    responsive: 'scroll',
    rowsPerPage: familiaresStore.params.limit,
    count: familiaresStore.pagination.totalItems,
    page: familiaresStore.pagination.currentPage - 1,
    rowsPerPageOptions: [50, 100],
    print: false,
    textLabels,
    selectableRowsHideCheckboxes: true,
    expandableRows: true,
    renderExpandableRow: (rowData, rowMeta) => {
      const data = familiaresStore.all.find(({ id }) => id === rowData[0]);
      const colSpan = rowData.length + 1;
      return (
        data && (
          <TableRow>
            <TableCell colSpan={colSpan}>
              <DetalleExpandeFamiliares data={data} />
            </TableCell>
          </TableRow>
        )
      );
    },
    serverSide: true,
    onSearchChange: (searchQuery) => {
      if (searchQuery) {
        clearTimeout(intervalSearch);
        intervalSearch = setTimeout(() => {
          const payload = {
            ...familiaresStore.params,
            q: searchQuery,
          };
          dispatch({ type: PARAMS_FAMILIARES, payload });
          all(payload);
        }, 800);
      }
    },
    onSearchClose: () => {
      const payload = {
        ...familiaresStore.params,
        q: null,
        page: 1,
      };
      dispatch({ type: PARAMS_FAMILIARES, payload });
      all(payload);
    },
    onChangePage: async (currentPage) => {
      const payload = {
        ...familiaresStore.params,
        page: currentPage + 1,
      };
      dispatch({
        type: PARAMS_FAMILIARES,
        payload,
      });
      all(payload);
    },
    onChangeRowsPerPage: async (numberOfRows) => {
      const payload = {
        ...familiaresStore.params,
        limit: numberOfRows,
        page: 1,
      };
      dispatch({
        type: PARAMS_FAMILIARES,
        payload,
      });
      all(payload);
    },
  };

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        <LoadingWidget isLoading={familiaresStore.loadingAll || loading} />
        <MUIDataTable
          title="Listado"
          data={rows}
          columns={columns}
          options={options}
        />
      </Grid>
      {familiaresStore.activo && (
        <DeleteModalComponent
          open={openModalDelete}
          onClose={() => setOpenModalDelete(!openModalDelete)}
          onDelete={_onDeleteHandler}
        >
          <Typography variant="h6">
            <strong>Estudiante: </strong> <br />
            {`${familiaresStore.activo.familiar.perfil.pnombre} ${
              familiaresStore.activo.familiar.perfil.snombre
                ? familiaresStore.activo.familiar.perfil.snombre
                : ''
            } ${familiaresStore.activo.familiar.perfil.papellido} ${
              familiaresStore.activo.familiar.perfil.sapellido
                ? familiaresStore.activo.familiar.perfil.sapellido
                : ''
            }`}
          </Typography>
        </DeleteModalComponent>
      )}
    </Grid>
  );
};

export default ListadoFamiliares;
